import { createContext, useState, useEffect } from "react";

export const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const fetchCustomer = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            // Handle case where the user is not logged in or the token is not available
            console.error("No token found");
            setLoader(false); // Stop loading if there's an error
            return;
          }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/auth/me`,
          {
            method: "GET",
            headers: {
             "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const data = await response.json();
        setCustomer(data?.detail);
      } catch (error) {
        console.error("Failed to fetch user:", error);
      } finally{
        setLoader(false);
      }
    };
    fetchCustomer();
  }, []);

  return (
    <CustomerContext.Provider value={{ customer, loader }}>
      {children}
    </CustomerContext.Provider>
  );
};
